import { customRef } from '@vue/reactivity';
export function useLocalStorage(key, defaultValue = null) {
    return customRef((track, trigger) => ({
        get() {
            track();
            try {
                const value = localStorage.getItem(key);
                if (value)
                    return JSON.parse(value);
            }
            catch (error) {
                if (typeof window !== 'undefined') {
                    console.error(error);
                }
            }
            return defaultValue;
        },
        set(value) {
            try {
                if (value === null) {
                    localStorage.removeItem(key);
                }
                else {
                    localStorage.setItem(key, JSON.stringify(value));
                }
            }
            catch (error) {
                if (typeof window !== 'undefined') {
                    console.error(error);
                }
            }
            trigger();
        },
    }));
}
//# sourceMappingURL=useLocalStorage.js.map